import useSWR from 'swr';
import { fetcher } from '../../services/fetcher';
import { useClients } from '../clients';

export interface DashboardStats {
  totalClients: number;
  pendingTodos?: number;
}

interface DashboardStatsResponse extends DashboardStats {
  total?: { overview?: { totalTodos?: number } };
  user?: { overview?: { totalTodos?: number } };
}

export const useDashboardStats = (scope?: 'myWork' | 'team') => {
  const { data, error, isLoading, mutate } = useSWR<DashboardStatsResponse>(
    '/dashboard/stats',
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      refreshInterval: 30000,
    },
  );

  const { total: totalClients } = useClients(undefined, false);

  const useMyWorkPendingTodos = scope === 'myWork' && data?.user?.overview;
  const pendingTodos = useMyWorkPendingTodos
    ? (data!.user!.overview!.totalTodos ?? data?.total?.overview?.totalTodos ?? 0)
    : (data?.total?.overview?.totalTodos ?? data?.pendingTodos ?? 0);

  return {
    stats: {
      totalClients: data?.totalClients ?? totalClients ?? 0,
      pendingTodos,
    },
    isLoading,
    isError: error,
    mutate,
  };
};
